import { AddInError } from '@utils-global';

export class PostReportActionError extends AddInError {
  public cause?: unknown;

  constructor(message: string, context?: Record<string, unknown>, cause?: unknown) {
    super(message, context);
    this.name = 'PostReportActionError';
    this.cause = cause;
    Object.setPrototypeOf(this, PostReportActionError.prototype);
  }
}
